// extracted by mini-css-extract-plugin
export var layoutContainer = "_cz-0";
export var layoutContainerNoRounding = "_cz-6";
export var layoutContainerOpen = "_cz-5";
export var layoutContainerResizing = "_cz-1";
export var mainContent = "_cz-2";
export var resizeDivider = "_cz-3";
export var slidePanel = "_cz-4";